<crwd-modal-panel
  [title]="'messaging.channels.create-title' | translate"
  [showCloseButton]="false"
  (closed)="dismiss()">

  <div class="form-group">
    <label class="field-label">{{ 'messaging.channels.name-label' | translate }}</label>
    <div class="name-input-wrapper">
      <span class="hash-prefix">#</span>
      <input
        [(ngModel)]="channelName"
        [placeholder]="'messaging.channels.name-placeholder' | translate"
        type="text"
        maxlength="80"
        class="channel-name-input">
    </div>
    @if (nameError) {
      <div class="error-text">{{ nameError | translate }}</div>
    }
    <div class="hint-text">{{ 'messaging.channels.name-hint' | translate }}</div>
  </div>

  <div class="form-group">
    <label class="field-label">{{ 'messaging.channels.description-label' | translate }}</label>
    <crwd-textarea
      [(ngModel)]="description"
      [placeholder]="'messaging.channels.description-placeholder' | translate"
      [rows]="2"
      [maxlength]="250" />
  </div>

  <div class="form-group">
    <label class="field-label">{{ 'messaging.channels.visibility-label' | translate }}</label>
    <div class="toggle-row">
      <crwd-toggle
        [checked]="channelType === 'private'"
        (checkedChange)="toggleChannelType()"
        [ariaLabel]="'messaging.channels.visibility-label' | translate" />
      <span class="toggle-label">
        @if (channelType === 'public') {
          <crwd-icon name="globe-outline"></crwd-icon>
          {{ 'messaging.channels.type-public' | translate }}
        } @else {
          <crwd-icon name="lock-closed-outline"></crwd-icon>
          {{ 'messaging.channels.type-private' | translate }}
        }
      </span>
    </div>
    <div class="hint-text">
      @if (channelType === 'public') {
        {{ 'messaging.channels.public-hint' | translate }}
      } @else {
        {{ 'messaging.channels.private-hint' | translate }}
      }
    </div>
  </div>

  @if (channelType === 'private' && contacts.length > 0) {
    <div class="form-group">
      <label class="field-label">{{ 'messaging.channels.members-label' | translate }}</label>
      <div class="member-list">
        @for (contact of contacts; track contact.id) {
          <div class="member-item" [class.disabled]="contact.id === user.user?.uid" (click)="toggleMember(contact.id)">
            <crwd-avatar
              class="contact-avatar"
              shape="square"
              [size]="24"
              [name]="contact.name"
              [src]="contact.avatar" />
            <span class="member-name">{{ contact.name }} @if (contact.id === user.user?.uid) { <span class="you-badge">you</span> }</span>
            <input type="checkbox" [checked]="isMemberSelected(contact.id)" [disabled]="contact.id === user.user?.uid" class="member-checkbox" (click)="$event.stopPropagation()">
          </div>
        }
      </div>
    </div>
  }

  

  <crwd-button modal-footer variant="outline" (pressed)="dismiss()">
    {{ 'common.buttons.cancel' | translate }}
  </crwd-button>
  <crwd-button modal-footer variant="primary"
    (pressed)="createChannel()"
    [disabled]="loading || !channelName.trim()">
    @if (loading) {
      <span class="spinner"></span>
    } @else {
      {{ 'messaging.channels.create-btn' | translate }}
    }
  </crwd-button>

</crwd-modal-panel>
